import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialDesignModule } from './common/material-design/material-design.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabTestsListComponent } from './components/lab-tests-list/lab-tests-list.component';
import { MatPaginator } from '@angular/material/paginator';

import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { ViewNotesComponent } from './components/view-notes/view-notes.component';
import { LoginComponent } from './components/login/login.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { GenerateReportPopupComponent } from './components/generate-report-popup/generate-report-popup.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import en from '@angular/common/locales/en';
import { CreateProjectComponent } from './components/create-project/create-project.component';
import { ProjectsListComponent } from './components/projects-list/projects-list.component';
import { InclusiveDatesComponent } from './common/inclusive-dates/inclusive-dates.component';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AccessErrorComponent } from './common/access-error/access-error.component';
import { FinalSampleInputsComponent } from './components/final-sample-inputs/final-sample-inputs.component';
import { appProviders } from './app.providers';
export { US_DATE_FORMATS } from './app.constants';

registerLocaleData(en);

@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialDesignModule,
    BrowserAnimationsModule,
    ReactiveFormsModule, FormsModule,
    MatPaginator,
    MatExpansionModule,
    DragDropModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    PortalModule,
    OverlayModule,
    ToastrModule.forRoot({
      closeButton: true
    }),
    MatCheckboxModule,
    MsalModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AppComponent,
    CreateProjectComponent,
    ViewNotesComponent,
    AccessErrorComponent,
    FooterComponent,
    HeaderComponent,
    InclusiveDatesComponent,
    FinalSampleInputsComponent,
    GenerateReportPopupComponent,
    LabTestsListComponent,
    LoginComponent,
    ProjectsListComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: appProviders,
  bootstrap: [AppComponent, MsalRedirectComponent]

})
export class AppModule { }